import { useEffect } from "react";

const SITE = "https://whaynsdijital.com";
const BRAND = "Whayns Dijital";

export function useSEO({ title, description, path, type = "website", image, article, schema }) {
  useEffect(() => {
    // Title
    const fullTitle = title ? `${title} | ${BRAND}` : `${BRAND} | Reklam & Pazarlama Ajansı`;
    document.title = fullTitle;

    // Meta tags
    const setMeta = (name, content) => {
      if (!content) return;
      // name attribute
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const setOG = (property, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("property", property);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const desc = description || "Türkiye'nin tam kapsamlı reklam ve pazarlama ajansı. Marka stratejisi, dijital reklam, sosyal medya, SEO, e-ticaret ve web tasarım.";
    const url = path ? `${SITE}${path}` : SITE;
    const img = image || `${SITE}/og-image.png`;

    setMeta("description", desc);
    setOG("og:title", fullTitle);
    setOG("og:description", desc);
    setOG("og:url", url);
    setOG("og:type", type);
    setOG("og:image", img);
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
    setMeta("twitter:image", img);

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    // Dynamic Schema.org JSON-LD
    const existingSchema = document.getElementById("dynamic-schema");
    if (existingSchema) existingSchema.remove();

    if (schema || article) {
      const schemaTag = document.createElement("script");
      schemaTag.id = "dynamic-schema";
      schemaTag.type = "application/ld+json";

      if (article) {
        // Blog Article schema
        schemaTag.textContent = JSON.stringify({
"@context": "https://schema.org",
"@type": "Article",
"headline": article.title,
"description": article.excerpt || desc,
"image": article.coverImage ? `${SITE}${article.coverImage}` : img,
"author": {
"@type": "Person",
"name": article.author || BRAND
          },
"publisher": {
"@type": "Organization",
"name": BRAND,
"logo": { "@type": "ImageObject", "url": `${SITE}/logo512.png` }
          },
"datePublished": article.date,
"dateModified": article.date,
"mainEntityOfPage": { "@type": "WebPage", "@id": url },
"articleSection": article.category || "Blog",
"inLanguage": "tr",
"keywords": article.keywords || article.category || ""
        });
      } else if (schema) {
        schemaTag.textContent = JSON.stringify(schema);
      }

      document.head.appendChild(schemaTag);
    }

    // Cleanup
    return () => {
      const s = document.getElementById("dynamic-schema");
      if (s) s.remove();
    };
  }, [title, description, path, type, image, article, schema]);
}